import { Button, Typography } from "@mui/material";
import styled from "styled-components";

export const Container = styled.form`
  background: ${({ theme }) => theme.palette.background.paper};
  width: 502px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: 25px;
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
`;

export const SwitchContainer = styled.div<{
  isActive: boolean;
  editMode: boolean;
}>`
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.palette.success.main : theme.palette.error.main};
  border-radius: 25px;
  align-items: center;
  display: flex;
  margin-left: 15px;
  padding: ${({ editMode }) =>
    editMode ? "5px 5px 5px 15px" : "5px 15px 5px 15px"};
`;

export const IsActiveText = styled(Typography)<{ isActive: boolean }>`
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.success.main : theme.palette.error.main};
  min-width: 49px;
  text-align: center;
`;

export const ActionsContainer = styled.div<{ editMode: boolean }>`
  margin-top: 35px;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: ${({ editMode }) =>
    editMode ? "space-between" : "flex-end"};
`;

export const ActionContainer = styled(Button)`
  display: flex;
  align-items: center;
  transition: opacity 0.2s !important;

  &:hover {
    opacity: ${({ theme }) => theme.palette.action.hoverOpacity};
    background-color: transparent !important;
  }
`;

export const AlignEndContainer = styled.div``;
